export function calculateTax(
  inclusiveAmount: number,
  taxRate: number = 0
): number {
  const preTaxAmount = inclusiveAmount - inclusiveAmount / (1 + taxRate / 100);
  return preTaxAmount;
}
